// extracted by mini-css-extract-plugin
export default {"title":"PlatformErrorCodes_title__EGInC","description":"PlatformErrorCodes_description__JUUBT"};